import { Button, styled } from "@mui/material";

export const MainCTABtn = styled(Button)(({ theme }) => ({
  borderRadius: 8,
  padding: theme.spacing(1),
  textTransform: "none",
  fontWeight: 600,
  boxShadow: "0 2px 8px rgba(10, 118, 250, 0.2)",
}));

